import React, { useMemo } from 'react';
import Select from 'react-select';
import { selectStyles, MESSAGE_CREATED_BY_OPTIONS, MESSAGE_AUDIENCE_OPTIONS, MESSAGE_SEND_KIND_OPTIONS, SENT_MESSAGE_DELIVERY_STATUS } from '../../utils';
import DateRangePicker from '../common/DateRangePicker/DateRangePicker';
import { MdSearch, MdRefresh } from "react-icons/md";

const PLATFORM_OPTIONS = [
    { value: 'Android', label: 'Android' },
    { value: 'iOS', label: 'iOS' },
    { value: 'Web', label: 'Web' },
];

/** Source + Platform + date range. */
export default function SentMessagesFiltersBar({ draftFilters, setDraftFilters, onSearch, onReset }) {

    const statusValue = useMemo(() => {
        const v = draftFilters.status;
        if (v === '' || v === null || v === undefined) return null;
        return SENT_MESSAGE_DELIVERY_STATUS.find((o) => Number(o.value) === Number(v))
            || { value: v, label: String(v) };
    }, [draftFilters.status]);

    const sentFromValue = useMemo(() => {
        const v = draftFilters.sentFrom;
        if (v === '' || v === null || v === undefined) return null;
        return MESSAGE_CREATED_BY_OPTIONS.find((o) => Number(o.value) === Number(v))
            || { value: v, label: String(v) };
    }, [draftFilters.sentFrom]);

    const platformValue = useMemo(() => {
        const v = draftFilters.platform;
        if (!v || v === 'All Platforms') return null;
        return PLATFORM_OPTIONS.find((o) => o.value === v) || { value: v, label: v };
    }, [draftFilters.platform]);

    const audienceValue = useMemo(() => {
        const v = draftFilters.audience_type;
        if (v === '' || v === null || v === undefined) return null;
        return MESSAGE_AUDIENCE_OPTIONS.find((o) => Number(o.value) === Number(v))
            || { value: v, label: String(v) };
    }, [draftFilters.audience_type]);

    const sendKindValue = useMemo(() => {
        const v = draftFilters.sendKind;
        if (v === '' || v === null || v === undefined) return null;
        return MESSAGE_SEND_KIND_OPTIONS.find((o) => Number(o.value) === Number(v))
            || { value: v, label: String(v) };
    }, [draftFilters.sendKind]);

    return (
        <div className="list-page-filter-bar">
            <div className="list-page-filter-fields row g-3 align-items-end">
                <div className="list-page-filter-field col-12 col-lg-4">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Notification ID"
                        value={draftFilters.notificationId || ''}
                        onChange={(e) =>
                            setDraftFilters((d) => ({ ...d, notificationId: e.target.value }))
                        }
                    />
                </div>
                <div className="list-page-filter-field col-12 col-lg-4">
                    <div style={{ minWidth: 0, width: '100%' }}>
                        <Select
                            inputId="sent-messages-status"
                            instanceId="sent-messages-status"
                            classNamePrefix="ns-sent-status"
                            isSearchable
                            isClearable
                            placeholder="Status"
                            aria-label="Status"
                            options={SENT_MESSAGE_DELIVERY_STATUS}
                            value={statusValue}
                            onChange={(opt) =>
                                setDraftFilters((d) => ({ ...d, status: opt?.value ?? '' }))
                            }
                            styles={selectStyles}
                            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                            menuPosition="fixed"
                        />
                    </div>
                </div>
                <div className="list-page-filter-field col-12 col-lg-4">
                    <div style={{ minWidth: 0, width: '100%' }}>
                        <Select
                            inputId="sent-messages-created-by"
                            instanceId="sent-messages-created-by"
                            classNamePrefix="ns-sent-created-by"
                            isSearchable
                            isClearable
                            placeholder="Source"
                            aria-label="Source"
                            options={MESSAGE_CREATED_BY_OPTIONS}
                            value={sentFromValue}
                            onChange={(opt) =>
                                setDraftFilters((d) => ({ ...d, sentFrom: opt?.value ?? '' }))
                            }
                            styles={selectStyles}
                            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                            menuPosition="fixed"
                        />
                    </div>
                </div>
                <div className="list-page-filter-field col-12 col-lg-4">
                    <div style={{ minWidth: 0, width: '100%' }}>
                        <Select
                            inputId="sent-messages-audience"
                            instanceId="sent-messages-audience"
                            classNamePrefix="ns-sent-audience"
                            isSearchable
                            isClearable
                            placeholder="Audience"
                            aria-label="Audience"
                            options={MESSAGE_AUDIENCE_OPTIONS}
                            value={audienceValue}
                            onChange={(opt) =>
                                setDraftFilters((d) => ({ ...d, audience_type: opt?.value ?? '' }))
                            }
                            styles={selectStyles}
                            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                            menuPosition="fixed"
                        />
                    </div>
                </div>
                <div className="list-page-filter-field col-12 col-lg-4">
                    <div style={{ minWidth: 0, width: '100%' }}>
                        <Select
                            inputId="sent-messages-send-kind"
                            instanceId="sent-messages-send-kind"
                            classNamePrefix="ns-sent-send-kind"
                            isSearchable
                            isClearable
                            placeholder="Type"
                            aria-label="Type"
                            options={MESSAGE_SEND_KIND_OPTIONS}
                            value={sendKindValue}
                            onChange={(opt) =>
                                setDraftFilters((d) => ({ ...d, sendKind: opt?.value ?? '' }))
                            }
                            styles={selectStyles}
                            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                            menuPosition="fixed"
                        />
                    </div>
                </div>
                <div className="list-page-filter-field col-12 col-lg-4">
                    <div style={{ minWidth: 0, width: '100%' }}>
                        <Select
                            inputId="sent-messages-platform"
                            instanceId="sent-messages-platform"
                            classNamePrefix="ns-sent-platform"
                            isSearchable
                            isClearable
                            placeholder="Platform"
                            aria-label="Platform"
                            options={PLATFORM_OPTIONS}
                            value={platformValue}
                            onChange={(opt) =>
                                setDraftFilters((d) => ({ ...d, platform: opt?.value ?? '' }))
                            }
                            styles={selectStyles}
                            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                            menuPosition="fixed"
                        />
                    </div>
                </div>
                <div className="list-page-filter-field col-12 col-lg-4">
                    <DateRangePicker
                        dateFrom={draftFilters.dateFrom || ''}
                        dateTo={draftFilters.dateTo || ''}
                        preset={draftFilters.datePreset || ''}
                        onChange={({ dateFrom, dateTo, preset }) =>
                            setDraftFilters((d) => ({
                                ...d,
                                dateFrom: dateFrom || '',
                                dateTo: dateTo || '',
                                datePreset: preset || '',
                            }))
                        }
                        label=""
                        placeholder="Sent date"
                        allowClear
                    />
                </div>
                <div className="list-page-filter-field list-page-filter-actions col-12 col-lg-4">
                    <div className="add_app">
                        <button type="button" className="add_app_btn btn_theme_primary" title="Apply filters" onClick={onSearch}>
                            <MdSearch />
                            <span>Search</span>
                        </button>
                        <button type="button" className="add_app_btn_secondary btn_theme_secondary" title="Reset filters" onClick={onReset}>
                            <MdRefresh />
                            <span>Reset</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
